import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Tip from '../../../../shared/tip';
import Settings from './featured-wires-components/settings';
import {
  PremiumSectionSeparator, Section, SectionDetails,
} from './styles';
import Summary from './featured-wires-components/summary';
import { featuredWiresTip } from './consts';

const SSection = styled(Section)`
  ${props => props.theme.isMobile && `
    flex-direction: column;

    & > * {
      width: 100%;
      margin-left: 0;
    }
  `};
`;

const TipContainer = styled.div`
  border-bottom: 1px solid ${props => props.theme.secondaryColor30Transparent};
  margin-bottom: 30px;
`;

export default function FeaturedWires({ profileId, onUpdate }) {
  return (
    <>
      <PremiumSectionSeparator />
      <SSection>
        <Summary />
        <SectionDetails>
          <Settings {...{ profileId, onUpdate }} />
          <TipContainer>
            <Tip text={featuredWiresTip} />
          </TipContainer>
        </SectionDetails>
      </SSection>
    </>
  );
}

FeaturedWires.propTypes = {
  profileId: PropTypes.number.isRequired,
  onUpdate: PropTypes.func,
};

FeaturedWires.defaultProps = { onUpdate: () => null };
